class Address {
  constructor (builder) {
    Object.defineProperties(this, {
      number: {
        value: builder.number,
        writable: false
      },
      street: {
        value: builder.street,
        writable: false
      },
      neighbourhood: {
        value: builder.neighbourhood,
        writable: false
      },
      city: {
        value: builder.city,
        writable: false
      },
      state: {
        value: builder.state,
        writable: false
      },
      country: {
        value: builder.country,
        writable: false
      },
      fullAddress: {
        value: builder.fullAddress,
        writable: false
      }
    })
  }

  // it returns fullAddress if has value; properties concatenation in other case
  // fullAddress is used, for example, in case of ClickGo service
  toString () {
    return this.fullAddress ? this.fullAddress : (
    (this.street ? `${this.street}${this.number ? ` ${this.number}` : ''}` : '') +
    (this.neighbourhood ? `, ${this.neighbourhood}` : '') +
    (this.city ? `, ${this.city}` : '') +
    (this.state ? `, ${this.state}` : '') +
    (this.country ? `, ${this.country}` : ''))
  }

  static get Builder () {
    return Builder
  }
}

class Builder {
  setNumber (val) {
    this.number = val
    return this
  }

  setStreet (val) {
    this.street = val
    return this
  }

  setNeighbourhood (val) {
    this.neighbourhood = val
    return this
  }

  setCity (val) {
    this.city = val
    return this
  }

  setState (val) {
    this.state = val
    return this
  }

  setCountry (val) {
    this.country = val
    return this
  }

  setFullAddress (val) {
    this.fullAddress = val
    return this
  }

  build () {
    return new Address(this)
  }
}

export default Address



// WEBPACK FOOTER //
// ./src/models/address.js